import { db } from '../lib/firebase';
import { doc, writeBatch } from 'firebase/firestore';

/**
 * Batch saves scanned contracts to the 'contracts' collection to build the repository.
 * Uses merge: true to avoid overwriting existing detailed analysis.
 */
export async function saveScannedContracts(contracts: any[]) {
    if (!contracts || contracts.length === 0) return;

    try {
        const batch = writeBatch(db);
        let operationCount = 0;

        contracts.forEach(opp => {
            if (!opp.noticeId) return;

            // Use noticeId as doc ID for uniqueness
            const docRef = doc(db, 'contracts', opp.noticeId);

            // We use set with merge to update existing but keep new fields
            batch.set(docRef, {
                ...opp,
                lastScannedAt: new Date().toISOString()
            }, { merge: true });

            operationCount++;
        });

        if (operationCount > 0) {
            await batch.commit();
            console.log(`Persisted ${operationCount} contracts to repository.`);
        }
    } catch (err) {
        console.error("Error persisting scan results:", err);
        // Non-blocking error
    }
}
